import React from 'react';
import clsx from 'clsx';
import styles from '../../SummaryCard.module.css';
import { TValueProps } from '../SummaryCardColumn.helpers';

export const Value = ({
  children,
  value,
  className,
  offerSelection: { offerIsSelected, offerNotSelected },
}: TValueProps) => {
  return (
    <div
      className={clsx(
        styles.valueContainer,
        {
          [styles.selectedValueContainer]: offerIsSelected,
          [styles.unselectedValueContainer]: offerNotSelected,
        },
        className,
      )}
    >
      {children || (
        <p
          className={clsx(styles.value, {
            [styles.selectedValue]: offerIsSelected,
            [styles.unselectedValue]: offerNotSelected,
          })}
        >
          {value}
        </p>
      )}
    </div>
  );
};
